import { FC } from 'react';
import PrismAPI from '@modules/prism-client/types/prism-types';
import { ButtonProps as WebCompositionsButtonProps, Button as WebCompositionsButton } from '@tuic/web-compositions/core/Button';
import { Link } from './Link';
import { telemetryToClickAttributes } from '@modules/prism-client/lib/telemetry';
type Props = WebCompositionsButtonProps & {
  data: PrismAPI.ButtonElement;
};
export const Button: FC<Props> = props => {
  return <WebCompositionsButton {...apiButtonToButtonProps(props)} data-sentry-element="WebCompositionsButton" data-sentry-component="Button" data-sentry-source-file="Button.tsx" />;
};
export const apiButtonToButtonProps = ({
  data,
  ...props
}: Props): WebCompositionsButtonProps => {
  const children = data.link ? <Link data={data.link}>{props.children ?? data.label}</Link> : props.children ?? data.label;
  return {
    ...telemetryToClickAttributes(data.telemetry),
    ...props,
    variant: data.variant ?? props.variant,
    on: data.on ?? props.on,
    iconLeft: data.iconLeft ?? props.iconLeft,
    iconRight: data.iconRight ?? props.iconRight,
    asChild: props.asChild ?? !!data.link,
    type: data.htmlType ?? props.type,
    children
  };
};